/**
 * The view-as start and stop endpoints, injected beside the generated client because they predate its regeneration.
 * Both opt out of the view-as header: the backend's admin-only guard reads the identity the request runs as, and with
 * the header that would be the target, who is never an admin.
 */
import type { ViewAsStatus } from 'src/lib/view-as/view-as-response';
import { rtkQueryBase } from 'src/store/rtk-query-base';

export interface ViewAsTargetArg {
  readonly targetEmail: string;
}

const viewAsApi = rtkQueryBase.injectEndpoints({
  endpoints: (build) => ({
    viewAsStart: build.mutation<ViewAsStatus, ViewAsTargetArg>({
      query: ({ targetEmail }) => ({
        url: '/permissions/view-as/start',
        method: 'POST',
        body: { targetEmail },
        withoutViewAs: true,
      }),
    }),
    viewAsStop: build.mutation<void, ViewAsTargetArg>({
      query: ({ targetEmail }) => ({
        url: '/permissions/view-as/stop',
        method: 'POST',
        body: { targetEmail },
        withoutViewAs: true,
      }),
    }),
  }),
});

export const { useViewAsStartMutation, useViewAsStopMutation } = viewAsApi;
